export default function CpfInput({ value, onChange, required = false }) {
  return (
    <input
      type="text"
      placeholder="CPF"
      className="input"
      value={value}
      onChange={onChange}
      required={required}
      maxLength={14}
    />
  );
}
